const VALID_CONNECTIONS = ['3g', '4g'];
const DEFINITION_NAME = 'embed/v3/form';
const SCRIPT_NAME = 'new-embed-script.js';
let _shouldMeasure = true;

function getEntry(key) {
  return performance.getEntriesByType('resource').filter(function (entry) {
    return entry.name.indexOf(key) > -1;
  })[0];
}

export function track(key, value) {
  if (!_shouldMeasure) {
    return;
  }
  const url =
    window.perfHsFormsUrl +
    '/embed/v3/timings.gif?key=' +
    key +
    '&valueInMs=' +
    value;
  const image = new Image();
  image.src = url;
}

export function shouldMeasure() {
  if (document.visibilityState !== 'visible') {
    _shouldMeasure = false;
  }

  if (
    !(
      window.navigator.connection &&
      VALID_CONNECTIONS.indexOf(window.navigator.connection.effectiveType) > -1
    )
  ) {
    _shouldMeasure = false;
  }
}

export function measureScript() {
  const duration = getEntry(SCRIPT_NAME).duration;

  track('embed-script', duration);
}

export function measureDefinitionRequest() {
  const duration = getEntry(DEFINITION_NAME).duration;

  track('fetch-definition', duration);
}

export function measureRender() {
  const definitionMeasure = getEntry(DEFINITION_NAME);

  const renderDuration = performance.now() - definitionMeasure.responseEnd;

  track('render', renderDuration);
}

export function measureRequests() {
  try {
    measureScript();
    measureDefinitionRequest();
    measureRender();
  } catch (error) {
    console.error(error);
  }
}

(function () {
  shouldMeasure();
})();
